<template>
  <div>
    <div style="margin-bottom:10px; scroll-behavior: smooth;">
      <b-row>
    <b-col align="center">
      <div class="contact-side-icon">
        <font-awesome-icon class="contact-side-icon" icon="list" size="sm" />
      <span 
      class="contact-side-icon"
        @click="contactTabSelected = false"
        v-bind:class="[
          { 'tab-head-home-active': !contactTabSelected },
          'tab-head-home',
        ]"
        style="margin-right:5px"
      >
       <strong> Recent Logs</strong> 
      </span>

      </div>
   

    </b-col>
    <b-col align="center">
      <div class="contact-side-icon"> 
        <font-awesome-icon  icon="address-book" size="sm" />
      <span class="contact-side-icon"
        @click="contactTabSelected = true"
        v-bind:class="[
          { 'tab-head-home-active': contactTabSelected },
          'tab-head-home',
        ]"
      >
      <strong> Contacts </strong>
      </span> 

      </div>
     
    </b-col>
  </b-row>
  
        <!-- <b-col align="center">
          <font-awesome-icon class="contact-side-icon" icon="list" size="sm" />
          <span
            @click="contactTabSelected = false"
            v-bind:class="[
              { 'tab-head-home-active': !contactTabSelected },
              'tab-head-home',
            ]"
            style="margin-right:5px"
          >
            <strong> Recent Logs</strong>
          </span>
        </b-col> -->
        <!-- <b-col align="center">
          <font-awesome-icon
            class="contact-side-icon"
            icon="address-book"
            size="sm"
          />
          <span
            @click="contactTabSelected = true"
            v-bind:class="[
              { 'tab-head-home-active': contactTabSelected },
              'tab-head-home',
            ]"
          >
            <strong> Contacts </strong>
          </span>
        </b-col>
      </b-row> -->

      <b-form-input
        id="input-small"
        :change="searchContact()"
        v-model="searchContactInput"
        size="sm"
        placeholder="Search"
        style="margin-top: 5px;"
      ></b-form-input>
      <!-- <h5 class="no-contact-found" v-if="!callLogs.filter(callLogs => !searchContactInput || callLogs.callerNumber.toLowerCase().includes(searchContactInput.toLowerCase()) || callLogs.callerName.toLowerCase().includes(searchContactInput.toLowerCase())).length  ">Contact Not Found</h5> -->
    </div>

    <div v-if="!contactTabSelected" class="call-logs-list">
      <div v-if="callLog() && callLog().length > 0">
        <b-row
        :key="index"
        v-for="(call, index) in callLog().filter(
          (callLogs) =>
            !searchContactInput ||
            callLogs.callerNumber
              .toLowerCase()
              .includes(searchContactInput.toLowerCase()) ||
            callLogs.callerName
              .toLowerCase()
              .includes(searchContactInput.toLowerCase())
        )"
        class="call-history-row"
      >
        <b-col cols="1">
          <font-awesome-icon
            class="missed-call-icon"
            v-if="call.callType == 'missed'"
            style="color:#DB4437; margin-top: 15px; margin-left: 15px;"
            icon="level-up-alt"
            size="lg"
          />
          <font-awesome-icon
            v-if="call.callType == 'outgoing'"
            style="color:#4285F4; margin-top: 15px; margin-left: 15px;"
            icon="arrow-up"
            size="lg"
          />
          <font-awesome-icon
            v-if="call.callType == 'incoming'"
            style="color:#0F9D58; margin-top: 15px; margin-left: 15px;"
            icon="arrow-down"
            size="lg"
          />
        </b-col>
        <b-col cols="7" class="contact-details">
          <strong>
            <p
              @click="openContactwithoutCallerIdandSearchwithnumberwithcontactlist(call.callerNumber)"
              class="call-history-values call-history-values-name"
            >
              {{ call.callerName }}
            </p>
          </strong>
          <p class="call-history-values call-history-values-number">
            {{ call.callerNumber }}
          </p>
          <p class="call-history-values call-history-values-date">
            {{ call.calledTime }}
          </p>
        </b-col>
        <b-col cols="2" class="text-left">
          <font-awesome-icon
            class="contact-side-icon-call"
            style="color:#636e72;cursor:pointer; margin-top: 15px; margin-left: 45px;"
            v-b-tooltip.hover
            title="Call"
            @click="
              dialFromHistory(call.callerName, call.callerNumber, call.callerId)
            "
            id="index"
            icon="phone-alt"
            size="sm"
          />
<!--         
          <font-awesome-icon
            class="contact-side-icon"
            v-if="call.callerName == 'Unknown Caller'"
            id="tooltip-target-4"
            style="color:#ccc;cursor:pointer"
            v-b-tooltip.hover
            title="Add Contact"
            variant="danger"
            @click="addContact(call.callerNumber)"
            icon="user-plus"
            size="sm"
          /> -->
      
        </b-col>
      </b-row>

      </div>
      <div v-else style="display: flex; justify-content: center;">

        <h6>No Recent Calls</h6>

      </div>
   
    </div>

    <div v-if="contactTabSelected" class="call-logs-list">
      <div v-if="contactList && contactList.length > 0">
        <b-row
        :key="index"
        v-for="(call, index) in contactList.filter(
          (contactList) =>
            !searchContactInput ||
            contactList.contactNumber
              .toLowerCase()
              .includes(searchContactInput.toLowerCase()) ||
            contactList.contactName
              .toLowerCase()
              .includes(searchContactInput.toLowerCase())
        )"
        class="call-history-row"
      >
        <b-col cols="1"
          ><font-awesome-icon
            style="color:#ccc; margin-top: 15px; margin-left: 15px;"
            icon="user"
            size="lg"
        /></b-col>
        <b-col cols="7">
          <strong>
            <p
              @click="openContact(call.contactNumber)"
              class="call-history-values call-history-values-name"
            >
              {{ call.contactName }}
            </p>
          </strong>
          <p class="call-history-values contact-values-number">
            {{ call.contactNumber }}
          </p>
        </b-col>
        <b-col cols="3" class="text-left">
          <font-awesome-icon
            class="contact-side-icon"
            style="color:#636e72;cursor:pointer; margin-top: 15px;margin-left: 35px;"
            v-b-tooltip.hover
            title="Call"
            id="tooltip-target-5"
            @click="
              dialFromHistory(
                call.contactName,
                call.contactNumber,
                call.callerId
              )
            "
            icon="phone-alt"
            size="sm"
          />
          <!-- <b-tooltip target="tooltip-target-5" triggers="hover">
                        Call
             </b-tooltip> -->
          <font-awesome-icon
            class="contact-side-icon"
            v-if="call.contactName == 'Unknown Caller'"
            v-b-tooltip.hover
            title="Add Contact"
            id="tooltip-target-6"
            style="color:#ccc;cursor:pointer"
            @click="addContact(call.contactNumber)"
            icon="user-plus"
            size="sm"
          />
          <!-- <b-tooltip target="tooltip-target-6" triggers="hover">
                        Add Contact
             </b-tooltip> -->
        </b-col>
      </b-row>

      </div>
      
        <div v-else style="display: flex; justify-content: center;">

        <h6>No Contacts Found</h6>

      </div>
   
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import "amazon-connect-streams";
import "amazon-connect-chatjs";
import { makeOutboundCall } from "../../../lib/CallActions";

export default {
  name: "CallContacts",
  components: {},
  data() {
    return {
      contactTabSelected: false,
      dialedNumber: "",
      searchContactInput: "",
    };
  },

  methods: {
    openContactwithoutCallerIdandSearchwithnumberwithcontactlist(contactNumber)
      {
        const normalizeNumber = (value) => {
          if (!value) return ''
          return value.toString().replace(/[^0-9]/g, '')
        }

        const searchNumber = normalizeNumber(contactNumber)
        if (!searchNumber) {
          console.warn('Invalid caller number', contactNumber)
          return
        }

        const contact = (this.contactList || []).find((item) => {
          const itemNumber = normalizeNumber(item.contactNumber || item.callerNumber)
          return (
            itemNumber === searchNumber ||
            itemNumber.endsWith(searchNumber) ||
            searchNumber.endsWith(itemNumber)
          )
        })

        if (contact) {
          const id = contact.callerId || contact.contactId
          if (id) {
            this.openContact(id)
            return
          }
        }

        console.warn('Contact ID not found for this number', contactNumber)
      },
    openContact(callerId) {
      var passData = {};
      passData.action = "OPEN_CONTACT";
      passData.callerId = callerId;
      console.log(passData);
      parent.postMessage(passData, "*");
    },
    dialFromHistory(name, number, id) {
      console.log(name, number);
      let res = makeOutboundCall(name, number);
      this.$store.dispatch("call/updateCallerName", name);
      this.$store.dispatch("actions/setOutboundCall", true);
      this.$store.dispatch("call/updateCallerId", id);
      this.$store.dispatch("call/updateOnOutboundFlag", true);
      console.log("MAKE OUTBOUND CALL", res);
    },
    addContact(number) {
      this.$store.dispatch("actions/setSaveNumber", number);
      this.$store.dispatch("actions/homeSubNavigation", "saveContact");
    },
    searchContact() {
      if (this.searchContactInput.length >= 3) {
        var passData = {};
        passData.action = "SEARCH_CONTACT";
        passData.text = this.searchContactInput;
        console.log(passData);
        parent.postMessage(passData, "*");
      }
    },
  callLog() {
  if (this.callLogs && this.callLogs.length > 0) {
      return this.callLogs.reduce((unique, o) => {
      if (!unique.some((obj) => obj.calledTime === o.calledTime)) {
          unique.push(o);
        }
        return unique;
      }, []);
    } else {
      return [];
    }
  }
  },
  computed: {
    ...mapGetters(["callLogs", "contactList", "dialedNumber"]),
  },
};
</script>

<style scoped>
p {
  padding-left: 50px;
  /* letter-spacing: 1px; */
}
.tab-head-home {
  color: #1d0658;
  font-size: 12px;
  cursor: pointer;
  border-color: #010103;
}

.tab-head-home-active {
  border-bottom: solid 2px #010103;
}

.contact-side-icon {
  margin-right: 5px;
  margin-left: 5px;
}
.contact-side-icon:hover {
  color: #2c5cc5 !important;
}

.call-logs-list {
  height: 343px;
  overflow-x: scroll;
  overflow-y: scroll;
}

.call-logs-list::-webkit-scrollbar {
  display: none;
}

.call-logs-list {
  -ms-overflow-style: none;
}

.call-history-row {
  padding: 5px 0;
}

.call-history-values {
  margin-bottom: 0px !important;
  text-align: left !important;
}

.call-history-values-name {
  font-size: 13px !important;
  cursor: pointer;
}

.call-history-values-name:hover {
  color: #2c5cc5;
}

.call-history-values-number {
  font-size: 12px !important;
}

.contact-values-number{
  font-size: 12px;
  /* color: #2c5cc5; */
  /* font-weight: bold; */
}

.call-history-values-date {
  font-size: 9px !important;
  /* color: #2c5cc5; */
  /* font-weight: bold; */
}

.call-history-values-right-buttons {
  display: inline-flex;
}


.call-history-values-right-buttons-icons {
  margin: 2px;
}

.call-history-values-right-buttons-icons:hover {
  color: #2c5cc5;

}
.no-contact-found {
  text-align: center;
  margin-top: 30px;
}

.hovertext {
  position: relative;
  border-bottom: 1px dotted black;
}

.hovertext:before {
  content: attr(data-hover);
  visibility: hidden;
  opacity: 0;
  width: 140px;
  background-color: black;
  color: #fff;
  text-align: center;
  border-radius: 5px;
  padding: 5px 0;
  transition: opacity 1s ease-in-out;

  position: absolute;
  z-index: 1;
  left: 0;
  top: 110%;
}

.hovertext:hover:before {
  opacity: 1;
  visibility: visible;
}
.contact-side-icon-call:hover {
  color: #2c5cc5 !important;
}
</style>
